import React from 'react'
import Parallax from '../Parallax'
import Plan from './Plan'
import Definition from './Definition'

import styles from './Accueil.module.scss';

function Accueil() {
  return (
    <div>
      {/*<Parallax image="ordre.jpg" alt="Bitardbourg" title="Bienvenue à Bitardbourg" />*/}
      <Parallax image="pierre-levee.jpg" alt="Pierre Levée" title="Bienvenue à Bitardbourg"/>
      <div className={styles.cards}>
        <div className="card">
            <img className={styles.img} src="/images/semaine/2026/affiche.png" alt="Affiche 2026"/>
        </div>
        <div className="card">
            <img className={styles.img} src="/images/semaine/2026/programme.png" alt="Programme 2026" />
        </div>
      </div>
      <Plan/>
      <Definition/>
      <Parallax image="chateau-eau.jpg" alt="Bitardbourg"/>
    </div>
  )
}

export default Accueil
